/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING : STYLES --------------- ++++++++++ */
export default theme => ({
    commenting: {
        // animate in copy and details on load
        // '& .name-page-copy': {
        //     opacity: '0',
        //     animationName: 'fadeInUp',
        //     animationDuration: '.2s',
        //     animationFillMode: 'forwards',
        //     animationDelay: '.1s',
        // },
        // '& .name-page-details': {
        //     opacity: '0',
        //     animationName: 'fadeInUp',
        //     animationDuration: '.2s',
        //     animationFillMode: 'forwards',
        //     animationDelay: '.175s',
        // }
    }
});
